import React, { useEffect, useRef, useState } from 'react'
import { useSelector} from 'react-redux'
import Sketch from 'react-p5';

const WebcamContent = () => {
  const font = '"Terminal ", monospace'
    const videoRef = useRef()
    const [captureWidth, setCaptureWidth] = useState(640)
    const [captureHeight, setCaptureHeight] = useState(480)
    // useEffect(() => {
    //     setCaptureHeight(p5ref.current.clientHeight)
    //     setCaptureWidth(p5ref.current.clientWidth)
    //     console.log(p5ref.current.clientHeight, p5ref.current.clientWidth)
    // }, [])

    const windowCheck = useSelector((state) => state.shower.window);
    useEffect(() => {
        if(windowCheck.find((w) => w.windowID === 'webcam-window').reset){
          reset()
        }
    },[windowCheck.find((w) => w.windowID === 'webcam-window').reset])
    
    const reset = () => {
        stopWebCam()
    }


    const startWebCam = () =>{

      if (navigator.mediaDevices.getUserMedia) {     navigator.mediaDevices.getUserMedia({ video: true })
        .then(stream => videoRef.current.srcObject = stream)
        .catch(error => console.log(error));
       }
      videoRef.current.play()
    }
    
    const stopWebCam = () =>{
      const stream = videoRef.current.srcObject;
      if(stream !== null){
        const tracks = stream.getTracks();
        tracks.forEach((track) => {
          track.stop();
        });
      }
    }
      
    return (
        <div id='webcam-content' style={{
          display: 'flex',
          flexFlow: 'column',
          fontFamily: font,
        }}>
          <div id='webcam' style={{
            margin:'auto',
            height: '75%',
          }}>
            <video width={700} height = {450} ref={videoRef} autoPlay style={{

              }}></video>
          </div>
          <div id='webcam-switches' style={{
            display: 'flex',
            flexFlow: 'row',
            margin: 'auto',
            fontFamily: font,
            //marginLeft: '10%',
            //marginRight: '10%',
            //justifyContent: 'space-between',
          }}>
              <button onClick={() => startWebCam()} style={{
                marginLeft: '10%',
                marginRight: '10%',
                backgroundColor:'rgb(76, 201, 240)',
                border: '2px outset rgb(76, 201, 240)',
                borderRadius: '5px',
                cursor: 'pointer',
                fontFamily: font, 
              }}>
                ▷
              </button>
              <button onClick={() => stopWebCam()}style={{
                marginLeft: '10%',
                marginRight: '10%',
                backgroundColor:'rgb(76, 201, 240)',
                border: '2px outset rgb(76, 201, 240)',
                borderRadius: '5px', 
                cursor: 'pointer',
                fontFamily: font,
              }}>
                ■
              </button>
          </div>
        </div>
    )
}

export default WebcamContent